import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import BrzwDatePicker from '../../../../brzw_date_picker';

import './date_time_selection_formik.scss';

const CLASS_NAME = 'date-selection-formik';
const TIME_FORMAT = 'hh:mm A';
const DATA_FORMAT = 'MMM DD, YYYY';

export class DateTimeSelectionFormik extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    const {
      field: { name },
      form: { setFieldValue },
      showTime,
      showTimeOnly,
    } = this.props;

    if (showTime && showTimeOnly) {
      setFieldValue(name, value.format(TIME_FORMAT));
    } else {
      setFieldValue(name, value.format(DATA_FORMAT));
    }
  }

  render() {
    const { className, disabled, field, form, showTime, showTimeOnly } = this.props;
    const { errors, submitCount, touched } = form;
    const { name, value } = field;
    let hasError = false;
    let additionalText = null;
    const shouldHandleError = (touched[name] || submitCount > 0) && errors[name];

    if (shouldHandleError) {
      hasError = true;
      additionalText = errors[name];
    }

    return (
      <BrzwDatePicker
        className={classnames(`${CLASS_NAME}__picker`, className, {
          'date-control__date-picker--disabled': disabled,
        })}
        customInput={
          <div className={CLASS_NAME}>
            <div
              className={classnames(`${CLASS_NAME}__toggle_wrapper`, {
                [`${CLASS_NAME}__toggle_wrapper--has-error`]: hasError,
              })}
            >
              <div className={`${CLASS_NAME}__toggle-left-side`}>
                <div className={classnames(`${CLASS_NAME}__toggle-calendar`, 'icon-calendar')} />
                <span className={`${CLASS_NAME}__toggle-label`}>{value}</span>
              </div>
              <div className={classnames(`${CLASS_NAME}__toggle-icon`, 'icon-down')} />
            </div>
            {hasError && <span className={`${CLASS_NAME}__error-label`}>{additionalText}</span>}
          </div>
        }
        disabled={disabled}
        onChange={this.onChange}
        withStyleguide
        popperModifiers={{
          preventOverflow: {
            enabled: true,
            escapeWithReference: false,
            boundariesElement: 'viewport',
          },
        }}
        showTimeSelect={showTime}
        showTimeSelectOnly={showTimeOnly}
      />
    );
  }
}

DateTimeSelectionFormik.propTypes = {
  activeDate: PropTypes.shape({}),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  field: PropTypes.shape({}),
  form: PropTypes.shape({}),
  showTime: PropTypes.bool,
  showTimeOnly: PropTypes.bool,
};

DateTimeSelectionFormik.defaultProps = {
  disabled: false,
  showTime: false,
  showTimeOnly: false,
};

export default DateTimeSelectionFormik;
